export enum SubscriptionActionsEnum {
	GET_SUBSCRIPTION = '[Subscription Api] Get subscription',
	UPGRADE_SUBSCRIPTION = '[Subscription] Upgrade',
}
